<div [className]="disabled ? 'deleted' : ''">
  @if (hat) {
    <div
      [class]="'hat-' + hatStyle + ' hat-' + hatWidth"
      [ngClass]="{
        'break-word card-group hat ': true,
        disabled: hatDisabledFlag,
      }"
    >
      @if (hatDisabledFlag) {
        <mat-icon class="disabled-icon s-12">not_interested</mat-icon>
      }
      <span [innerHTML]="highlightHat(hat)"></span>
    </div>
  }
  @if (group !== '') {
    <div [class]="groupStyle + ' break-word card-group'">
      @if (groupPrefixIcon) {
        <mat-icon
          [attr.data-testid]="groupPrefixIcon === 'svg_factur_x' ? 'facturx-icon' : 'ubl-icon'"
          [matTooltip]="groupPrefixIconTooltip"
          [svgIcon]="groupPrefixIcon"
          class="group-prefix-icon"
        ></mat-icon>
      }
      @if (groupCanceledFlag) {
        <mat-icon class="canceled-icon s-12" svgIcon="svg_canceled"></mat-icon>
      }
      @if (groupDisabledFlag || subGroupDisabledFlag) {
        <mat-icon class="disabled-icon s-12">not_interested</mat-icon>
      }
      @if (groupProceedFlag) {
        <mat-icon class="proceed-icon s-12" svgIcon="svg_proceed"></mat-icon>
      }
      <span
        [innerHTML]="highlightGroup(group)"
        [ngClass]="{
          disabled: groupDisabledFlag || groupCanceledFlag || groupProceedFlag,
          enabled: !groupDisabledFlag && !groupCanceledFlag && !groupProceedFlag,
        }"
      ></span>
      @if (subGroup) {
        <span
          [innerHTML]="' / ' + highlightSubgroup(subGroup)"
          [ngClass]="{
            disabled: subGroupDisabledFlag,
            enabled: !subGroupDisabledFlag,
          }"
        ></span>
      }
      @if (groupNote) {
        <span class="note">&nbsp;{{ groupNote }}</span>
      }
    </div>
  }
  @if (group === '') {
    <div class="grouped-card-empty-group"></div>
  }
  @if (title) {
    <div class="break-word card-list-title">
      <span [innerHTML]="highlightTitle(title)"></span>
    </div>
  }
  @if (label) {
    <div
      [ngClass]="{
        'active-text': labelStyle === 'active-text',
        'break-word': true,
        'card-label': !truncatedContentWidth,
        'grouped-card-label-truncated-small': truncatedContentWidth === 'small',
        'grouped-card-label-truncated-medium': truncatedContentWidth === 'medium',
        'grouped-card-label-truncated-large': truncatedContentWidth === 'large',
        'medium-text': labelStyle === 'medium-text',
        'unspecified-text': labelUnspecifiedFlag,
        'small-text': labelStyle === 'small-text',
      }"
      [title]="label"
    >
      @if (labelCanceledFlag) {
        <mat-icon class="disabled-icon s-12" svgIcon="svg_canceled"></mat-icon>
      }
      @if (labelDefaultFlag) {
        <mat-icon class="default-icon s-12">star</mat-icon>
      }
      @if (labelDisabledFlag) {
        <mat-icon class="disabled-icon s-12">not_interested</mat-icon>
      }
      @if (labelProceedFlag) {
        <mat-icon class="disabled-icon s-12" svgIcon="svg_proceed"></mat-icon>
      }
      <span [className]="labelDisabledFlag ? 'disabled' : 'enabled'" [innerHTML]="highlightLabel(label)"> </span>
    </div>
  }
  @if (showAttachmentIcon || showCommentIcon) {
    <div class="small-buttons">
      @if (showAttachmentIcon) {
        <button
          (click)="firstIconClickedEvent.emit()"
          [matTooltip]="hasAttachment ? attachmentActiveTooltip : attachmentInactiveTooltip"
          class="small-icon-button"
          data-testid="attachment-icon"
          mat-icon-button
        >
          <mat-icon [ngClass]="{ 'primary-fg': hasAttachment, inactive: !hasAttachment, 's-20': true }" svgIcon="svg_attachment"></mat-icon>
        </button>
      }
      @if (showCommentIcon) {
        <button
          (click)="secondIconClickedEvent.emit()"
          [matTooltip]="hasComment ? commentActiveTooltip : commentInactiveTooltip"
          class="small-icon-button"
          data-testid="comment-icon"
          mat-icon-button
        >
          <mat-icon [ngClass]="{ 'primary-fg': hasComment, inactive: !hasComment, 's-20': true }" svgIcon="svg_description"></mat-icon>
        </button>
      }
    </div>
  }
  @if (info) {
    <div
      [ngClass]="{
        'break-word card-info': true,
        'unspecified-text': infoUnspecifiedFlag,
        enabled: !infoUnspecifiedFlag,
      }"
    >
      @if (infoIcon && infoIcon.startsWith('svg')) {
        <mat-icon class="info-icon s-12" svgIcon="{{ infoIcon }}"></mat-icon>
      }
      @if (infoIcon && !infoIcon.startsWith('svg')) {
        <mat-icon class="info-icon s-12">{{ infoIcon }}</mat-icon>
      }
      <span [innerHTML]="highlightInfo(info)"></span>
    </div>
  }
  @if (infoLine2) {
    <div [class.warn-fg]="infoLine2WarnFlag" [class]="infoLine2Style + ' break-word card-info'">
      @if (infoLine2Icon && infoLine2Icon.startsWith('svg')) {
        <mat-icon class="info-icon s-12" svgIcon="{{ infoLine2Icon }}"></mat-icon>
      }
      @if (infoLine2Icon && !infoLine2Icon.startsWith('svg')) {
        <mat-icon class="info-icon s-12">{{ infoLine2Icon }}</mat-icon>
      }
      <span [innerHTML]="highlightInfoLine2(infoLine2)"></span>
    </div>
  }
  @if (infoLine3) {
    <div class="break-word card-info">
      <span [innerHTML]="highlightInfoLine3(infoLine3)"></span>
    </div>
  }
  @if (tags && tags.length > 0) {
    <div [title]="tags.join(', ')" class="card-tags">
      @for (tag of tags; track tag) {
        <span [innerHTML]="highlightTag(tag)" class="card-tag-chip"></span>
      }
    </div>
  }
</div>
